import styled, { css } from 'styled-components';

// ANIMATIONS
import { loading } from './animations';

// CONSTANTS
import { theme } from '../../constants/theme';
import { responsiveEndPoints } from '../../constants/responsive-endpoints';

// ENUMS
import { SkeletonTypes } from '../../enums/skeletonTypes';

// INTERFACES
import { ISkeleton } from '../../interfaces/Skeleton.interface';

export const Container = styled.span<ISkeleton>`
  display: block;
  background: ${theme.colors.primary.transparentBg};
  position: relative;
  overflow: hidden;

  &:before {
    content: '';
    position: absolute;
    left: -70%;
    top: 0;
    bottom: 0;
    animation: ${loading} 2s linear infinite;
  }

  ${({ type }) =>
    type == SkeletonTypes.BADGE &&
    css`
      padding: 13px;
      width: 117px;
      max-width: 117px;
      border-radius: 41px;
      &:before {
        width: 117px;
        opacity: 0.3;
        background: ${theme.colors.primary.transparentBorder};
        box-shadow: inset 0 0 5px ${theme.colors.primary.white};
        border-radius: 23px;
      }
    `}
    
  ${({ type }) =>
    type == SkeletonTypes.CARD &&
    css`
      padding: 35px;
      border-radius: 8px;
      &:before {
        min-width: 100%;
        opacity: 0.3;
        background: ${theme.colors.primary.transparentBorder};
        border-radius: 8px;
      }
    `}

  ${({ type, minWidthOf147px }) =>
    type == SkeletonTypes.HEADER &&
    css`
      padding: 16px;
      min-width: ${minWidthOf147px ? '147px' : '395px'};
      border-radius: 41px;
      &:before {
        min-width: ${minWidthOf147px ? '147px' : '395px'};
        opacity: 0.3;
        background: ${theme.colors.primary.transparentBorder};
        border-radius: 8px;
      }

      @media (max-width: ${responsiveEndPoints.responsive}px) {
        min-width: ${minWidthOf147px ? '30vw' : '60vw'};
        &:before {
          min-width: ${minWidthOf147px ? '30vw' : '60vw'};
        }
      }
    `}

    ${({ type }) =>
      type == SkeletonTypes.INITIALS &&
      css`
        font-size: 16px;
        display: flex;
        align-items: center;
        justify-content: center;
        text-transform: uppercase;
        color: ${theme.colors.secondary.blue400};
        letter-spacing: 0.06em;
        border-radius: 8px;
        font-family: 'Clan Pro';
        font-weight: ${theme.weights.regular};

        &:before {
          opacity: 0.3;
          background: ${theme.colors.secondary.gray500};
          box-shadow: inset 0 0 5px ${theme.colors.primary.white};
          border-radius: 0;
        }
      `}

  ${({ type, width, minWidthOf10px, height }) =>
    type == SkeletonTypes.TEXT &&
    css`
      padding: 8px;

      ${height ? `height: ${height}px;` : `padding: 8px;`}

      width: ${width ? `${width}px` : '80%'};
      min-width: ${minWidthOf10px ? '10px' : '100px'};

      border-radius: 4px;
      @media only screen and (max-width: 1365px) {
        padding: 13px;
      }
      &:before {
        width: 100%;
        opacity: 0.3;
        box-shadow: inset 0 0 5px ${theme.colors.primary.white};
        background: ${theme.colors.primary.transparentBorder};
        border-radius: 8px;
      }
    `}

  ${({ type }) =>
    type == SkeletonTypes.TIMELINE_INDICATOR &&
    css`
      position: absolute;
      z-index: 1;
      content: '';
      width: 8px;
      height: 8px;
      left: -4px;
      top: 0;
      bottom: 0;
      margin: auto;
      background: ${theme.colors.primary.transparentBorder};
      border-radius: 50%;
    `}

  ${({ type }) =>
    type == SkeletonTypes.TITLE &&
    css`
      padding: 8px;
      width: 76px;
      min-width: 76px;
      border-radius: 4px;
      margin-bottom: 4px;
      &:before {
        width: 100%;
        opacity: 0.3;
        background: ${theme.colors.primary.transparentBorder};
        border-radius: 8px;
      }
    `}
`;
